<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs"> Common Material Group / Nuevo CMG</p>
        <h2 class="">CMG</h2>
    </div>
</div>
<div class="dx-card content-block pt-3">
    <!-- TOP CONTAINER -->
    <div class="flex flex-nowrap">
        <!-- Left  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Categorias de CMG</h3>
            <div class="round-border-2 pt-0">
                <div class="dx-field">
                    <div class="dx-field-label">Department</div>
                    <div class="dx-field-value">
                        <dx-select-box [searchEnabled]="true" [dataSource]="departmentCBX" valueExpr="id" displayExpr="name" [(value)]="editCMG.departmentId">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Category</div>
                    <div class="dx-field-value">
                        <dx-select-box [searchEnabled]="true" [dataSource]="categoryCBX" valueExpr="id" displayExpr="name" [(value)]="editCMG.categoryId">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label"></div>
                    <div class="dx-field-value mt-2">
                        <dx-button id="button" [useSubmitBehavior]="true" type="default"
                            (onClick)="saveCMG($event)" text="Guardar CMG">
                        </dx-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Right  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Datos del CMG</h3>
            <div class="round-border-2">
                <div class="dx-field">
                    <div class="dx-field-label">CMG </div>
                    <div class="dx-field-value">
                        <dx-text-box maxLength="7" [(value)]="editCMG.code">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Nombre </div>
                    <div class="dx-field-value">
                        <dx-text-box maxLength="100" [(value)]="editCMG.name">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Descripcion </div>
                    <div class="dx-field-value">
                        <dx-text-area maxLength="100" stylingMode="outlined" [height]="90" [(value)]="editCMG.description">
                        </dx-text-area>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BOTOM CONTAINER -->
    <div class="flex flex-nowrap">
        <!-- Left  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Lideres CMG</h3>
            <div class="round-border-2">
                <div class="dx-field">
                    <div class="dx-field-label">Lider</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="usersList" [searchEnabled]="true" [hideSelectedItems]="false" (onValueChanged)="setLiderValue($event)" [(value)]="liderList" displayExpr="name" valueExpr="id"></dx-tag-box>
                    </div>
                </div>
            </div>
        </div>
        <!-- right  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Correos</h3>
            <div class="round-border-2">
                <div *ngFor="let item of correos; let indice=index;">
                    <div class="chip" *ngIf="item!=undefined">
                        <div class="chip-content">{{item.email}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BOTOM CONTAINER -->
    <div class="flex flex-nowrap">
        <!-- Left  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Buyers CMG</h3>
            <div class="round-border-2">
                <div class="dx-field">
                    <div class="dx-field-label">Buyer</div>
                    <div class="dx-field-value">
                        <dx-tag-box [dataSource]="usersList" [searchEnabled]="true" [hideSelectedItems]="false" (onValueChanged)="setBuyerValue($event)" [(value)]="buyerList" displayExpr="name" valueExpr="id"></dx-tag-box>
                    </div>
                </div>
            </div>
        </div>
        <!-- right  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Correos Buyer</h3>
            <div class="round-border-2">
                <div *ngFor="let item of correosBuyer; let indice=index;">
                    <div class="chip" *ngIf="item!=undefined">
                        <div class="chip-content">{{item.email}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>